import { render, staticRenderFns } from "./OptionList.vue?vue&type=template&id=52e4b105"
import script from "./OptionList.vue?vue&type=script&lang=ts"
export * from "./OptionList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports